module.exports = __webpack_public_path__ + "img/icon-detailed-records.e3d9caa9.svg";